import { Injectable, signal } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class InternalMenuService {
  private menuOpen = signal(false);
  public isOpen = this.menuOpen.asReadonly();

  public toggleMenu(newState?: boolean) {
    if (newState != undefined) {
      this.menuOpen.set(newState);
    } else {
      this.menuOpen.set(!this.menuOpen());
    }
  }
}
